export const isCustomerModePavillon = () => null;
